export const EMPTY_OBJECT = { };
export const EMPTY_FUNC = () => null;
